module.exports = __webpack_public_path__ + "assets/home_pin_blue.6904dd8a.svg";